import React from "react";

function Header() {
    return (
        <header>
            <h1>NOTE APP</h1>
        </header>
    );
}

export default Header;